(function () {
  'use strict';

  if (window.SDXToolsVersion === '1.2.1') return;
  window.SDXToolsVersion = '1.2.1';

  var UNKNOWN = 'Unknown. Confirm for your project.';
  var EVENTS = {
    sdx_tool_started: ['tool'],
    sdx_tool_completed: ['tool', 'result_count'],
    sdx_tool_reset: ['tool'],
    sdx_compare_updated: ['product_count'],
    sdx_product_opened: ['tool', 'handle'],
    sdx_story_opened: ['tool'],
    sdx_tool_error: ['tool', 'code'],
    sdx_plan_exported: ['tool', 'format']
  };
  var TOOLS = ['finder', 'compare', 'cost', 'heater', 'space'];
  var SAFE_CODES = ['data_unavailable', 'invalid_input', 'selection_required', 'render_failed'];

  function escapeHtml(value) {
    return String(value == null ? '' : value).replace(/[&<>'"]/g, function (character) {
      return ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', "'": '&#39;', '"': '&quot;' })[character];
    });
  }

  function finite(value) { return typeof value === 'number' && Number.isFinite(value); }
  function money(value, currency) {
    if (!finite(value)) return UNKNOWN;
    try { return new Intl.NumberFormat('en-US', { style: 'currency', currency: currency || 'USD', maximumFractionDigits: 2 }).format(value); }
    catch (_) { return '$' + value.toFixed(2); }
  }
  function text(value) { return value == null || value === '' ? UNKNOWN : escapeHtml(value); }
  function list(value) { return Array.isArray(value) && value.length ? value.map(escapeHtml).join(', ') : UNKNOWN; }
  function number(formData, name) {
    var raw = formData.get(name);
    if (raw === null || String(raw).trim() === '') return null;
    var parsed = Number(raw);
    return Number.isFinite(parsed) ? parsed : NaN;
  }
  function productData() {
    var payload = window.SDX_SAUNA_DATA;
    return payload && Array.isArray(payload.products) ? payload.products : null;
  }
  function focusResults(results) {
    if (!results) return;
    results.focus({ preventScroll: true });
    results.scrollIntoView({ behavior: window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth', block: 'start' });
  }
  function renderError(root, code, message) {
    var results = root.querySelector('[data-sdx-results]');
    if (results) results.innerHTML = '<div class="sdx-notice sdx-notice--error"><h2>We could not finish that check</h2><p>' + escapeHtml(message) + '</p><p><a href="/collections/saunas">Browse all saunas</a> or <a href="/pages/contact">contact SweatDecks</a>.</p></div>';
    emit('sdx_tool_error', { tool: root.getAttribute('data-sdx-tool'), code: code });
  }

  function emit(name, detail) {
    if (window.SweatDecksAnalyticsEnabled !== true) return;
    var allowed = EVENTS[name];
    if (!allowed) return;
    var safe = {};
    allowed.forEach(function (key) {
      var value = detail && detail[key];
      if (key === 'tool' && TOOLS.indexOf(value) !== -1) safe[key] = value;
      if (key === 'handle' && typeof value === 'string' && /^[a-z0-9-]{1,160}$/.test(value)) safe[key] = value;
      if ((key === 'result_count' || key === 'product_count') && Number.isInteger(value) && value >= 0 && value <= 100) safe[key] = value;
      if (key === 'code' && SAFE_CODES.indexOf(value) !== -1) safe[key] = value;
      if (key === 'format' && ['text', 'copy', 'print'].indexOf(value) !== -1) safe[key] = value;
    });
    try {
      if (window.Shopify && window.Shopify.analytics && typeof window.Shopify.analytics.publish === 'function') {
        window.Shopify.analytics.publish(name, safe);
      }
    } catch (_) { /* Analytics must never break a planning tool. */ }
    try { document.dispatchEvent(new CustomEvent(name, { detail: safe })); }
    catch (_) { /* Older browsers still retain full tool function. */ }
  }

  function planSummary(root, title) {
    var results = root.querySelector('[data-sdx-results]');
    var clone = results.cloneNode(true);
    clone.querySelectorAll('[data-sdx-plan-actions]').forEach(function (node) { node.remove(); });
    return [
      'SweatDecks planning summary',
      title,
      'Created: ' + new Date().toLocaleString('en-US'),
      '',
      clone.textContent.replace(/\s+/g, ' ').trim(),
      '',
      'Planning aid only. Confirm the current exact-model documents, product configuration, delivery eligibility, site conditions, utilities, clearances, permits, applicable code, and qualified-trade requirements before ordering or building.'
    ].join('\n');
  }

  function addPlanActions(root, title) {
    var results = root.querySelector('[data-sdx-results]');
    if (!results || results.querySelector('[data-sdx-plan-actions]')) return;
    var projectUrl = window.SDXProject && window.SDXProject.url ? window.SDXProject.url() : '/pages/sauna-project';
    var tool = root.getAttribute('data-sdx-tool');
    var project = window.SDXProject && window.SDXProject.read ? window.SDXProject.read() : null;
    var saved = Boolean(project && project.steps && project.steps[tool]);
    var heading = saved ? 'Saved to My Sauna Project' : 'Take this planning summary with you';
    var description = saved ? 'This result is connected to your other planning checks in this browser tab. No sign-in or submission is required.' : 'Browser storage is unavailable, but you can still download, copy, or print this result.';
    var projectAction = saved ? '<a class="sdx-button" href="' + escapeHtml(projectUrl) + '">View full project</a>' : '';
    results.insertAdjacentHTML('beforeend', '<section class="sdx-plan-actions" data-sdx-plan-actions data-sdx-plan-title="' + escapeHtml(title) + '"><div><h2>' + heading + '</h2><p>' + description + '</p></div><div class="sdx-actions">' + projectAction + '<button class="sdx-button sdx-button--secondary" type="button" data-sdx-export="text">Download this result</button><button class="sdx-button sdx-button--secondary" type="button" data-sdx-export="copy">Copy this result</button><button class="sdx-button sdx-button--secondary" type="button" data-sdx-export="print">Print / save PDF</button></div><p class="sdx-help" role="status" aria-live="polite" data-sdx-export-status></p></section>');
  }

  function saveProjectStep(tool, data, summary) {
    return Boolean(window.SDXProject && typeof window.SDXProject.saveStep === 'function' && window.SDXProject.saveStep(tool, data, summary));
  }

  function projectData(tool) {
    if (!window.SDXProject || typeof window.SDXProject.read !== 'function') return null;
    var project = window.SDXProject.read();
    return project && project.steps && project.steps[tool] ? project.steps[tool].data : null;
  }

  function removeProjectStep(tool) {
    if (window.SDXProject && typeof window.SDXProject.removeStep === 'function') window.SDXProject.removeStep(tool);
  }

  function hydrateForm(form, saved, names) {
    if (!saved) return;
    names.forEach(function (name) {
      if (!Object.prototype.hasOwnProperty.call(saved, name)) return;
      var controls = form.querySelectorAll('[name="' + name + '"]');
      controls.forEach(function (control) {
        if (control.type === 'radio') control.checked = String(control.value) === String(saved[name] == null ? '' : saved[name]);
        else if (control.type === 'checkbox') control.checked = saved[name] === true;
        else if (saved[name] != null) control.value = saved[name];
      });
    });
  }

  function copyText(value) {
    if (navigator.clipboard && typeof navigator.clipboard.writeText === 'function') return navigator.clipboard.writeText(value);
    return new Promise(function (resolve, reject) {
      var field = document.createElement('textarea');
      field.value = value;
      field.setAttribute('readonly', '');
      field.style.position = 'fixed';
      field.style.opacity = '0';
      document.body.appendChild(field);
      field.select();
      try { document.execCommand('copy') ? resolve() : reject(new Error('copy_failed')); }
      catch (error) { reject(error); }
      field.remove();
    });
  }

  function exportPlan(button) {
    var root = button.closest('[data-sdx-tool]');
    var actions = button.closest('[data-sdx-plan-actions]');
    if (!root || !actions) return;
    var format = button.getAttribute('data-sdx-export');
    var tool = root.getAttribute('data-sdx-tool');
    var value = planSummary(root, actions.getAttribute('data-sdx-plan-title') || 'Sauna plan');
    var status = actions.querySelector('[data-sdx-export-status]');
    if (format === 'text') {
      var blob = new Blob([value], { type: 'text/plain;charset=utf-8' });
      var url = URL.createObjectURL(blob);
      var link = document.createElement('a');
      link.href = url;
      link.download = 'sweatdecks-' + tool + '-planning-summary.txt';
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.setTimeout(function () { URL.revokeObjectURL(url); }, 0);
      status.textContent = 'Planning summary downloaded.';
    } else if (format === 'copy') {
      copyText(value).then(function () { status.textContent = 'Planning summary copied.'; }).catch(function () { status.textContent = 'Copy was blocked by the browser. Use Download .txt instead.'; });
    } else if (format === 'print') {
      document.body.classList.add('sdx-plan-printing');
      window.print();
      window.setTimeout(function () { document.body.classList.remove('sdx-plan-printing'); }, 0);
      status.textContent = 'Print dialog opened. Choose Save as PDF to keep a PDF copy.';
    }
    emit('sdx_plan_exported', { tool: tool, format: format });
  }

  function rankFinder(products, answers) {
    return products.filter(function (product) {
      if (answers.availableOnly && !product.available) return false;
      if (answers.capacity && (!finite(product.capacity) || product.capacity < answers.capacity)) return false;
      if (answers.placement && (!Array.isArray(product.placement) || product.placement.indexOf(answers.placement) < 0)) return false;
      if (answers.productType && product.productType !== answers.productType) return false;
      if (finite(answers.budget) && (!finite(product.price && product.price.min) || product.price.min > answers.budget)) return false;
      return true;
    }).map(function (product) {
      var score = product.available ? 3 : 0;
      var why = [];
      var tradeoffs = [];
      var known = 0;
      var considered = 0;

      if (answers.capacity) {
        considered += 1;
        if (finite(product.capacity)) {
          known += 1;
          if (product.capacity >= answers.capacity) {
            score += 35 - Math.min(12, (product.capacity - answers.capacity) * 2);
            why.push('Listed for ' + product.capacity + ', meeting your ' + answers.capacity + '-person target');
          } else {
            score -= 40;
            tradeoffs.push('Listed capacity is below your ' + answers.capacity + '-person target');
          }
        } else tradeoffs.push('Capacity is not confirmed');
      }
      if (answers.placement) {
        considered += 1;
        if (product.placement && product.placement.length) {
          known += 1;
          if (product.placement.indexOf(answers.placement) !== -1) {
            score += 25;
            why.push('Listed for ' + answers.placement + ' placement');
          } else {
            score -= 30;
            tradeoffs.push('Listed placement does not match your ' + answers.placement + ' preference');
          }
        } else tradeoffs.push('Placement is not confirmed');
      }
      if (answers.productType) {
        considered += 1;
        if (product.productType) {
          known += 1;
          if (product.productType === answers.productType) {
            score += 20;
            why.push('Matches your ' + answers.productType.toLowerCase() + ' style preference');
          } else {
            score -= 15;
            tradeoffs.push('Different style: ' + product.productType);
          }
        } else tradeoffs.push('Product style is not confirmed');
      }
      if (finite(answers.budget)) {
        considered += 1;
        if (finite(product.price && product.price.min)) {
          known += 1;
          if (product.price.min <= answers.budget) {
            score += 20;
            why.push('Current starting price is within your product budget');
          } else {
            score -= Math.min(35, 10 + Math.round((product.price.min - answers.budget) / Math.max(answers.budget, 1) * 20));
            tradeoffs.push('Current starting price is above your product budget');
          }
        } else tradeoffs.push('Current price is not confirmed');
      }
      if (product.available) why.push('Currently marked available in the store');
      else tradeoffs.push('Currently marked unavailable in the store');
      if (!product.heatType) tradeoffs.push('Heat type and final heater compatibility are not confirmed');

      return { product: product, score: score, why: why, tradeoffs: tradeoffs };
    }).sort(function (a, b) {
      return b.score - a.score || a.product.title.localeCompare(b.product.title);
    });
  }

  function resultCard(result, tool) {
    var product = result.product;
    var image = product.image && product.image.url ? '<div class="sdx-card__media"><img src="' + escapeHtml(product.image.url) + '" alt="' + escapeHtml(product.image.alt || product.title) + '" width="' + escapeHtml(product.image.width || 800) + '" height="' + escapeHtml(product.image.height || 600) + '" loading="lazy"></div>' : '';
    var why = result.why.length ? result.why : ['Eligible for a conservative catalog comparison'];
    var tradeoffs = result.tradeoffs.length ? result.tradeoffs : ['No tradeoff identified from the preferences supplied; project verification is still required'];
    var price = finite(product.price && product.price.min) ? 'From ' + money(product.price.min, product.price.currency) : 'Current price: ' + UNKNOWN;
    return '<article class="sdx-card">' + image + '<div class="sdx-card__body"><h3>' + escapeHtml(product.title) + '</h3><p class="sdx-card__meta">' + text(product.vendor) + ' · ' + text(product.productType) + '</p><p class="sdx-card__price">' + price + '</p><div class="sdx-card__section"><h4>Why it rose</h4><ul>' + why.map(function (item) { return '<li>' + escapeHtml(item) + '</li>'; }).join('') + '</ul></div><div class="sdx-card__section"><h4>Tradeoffs and checks</h4><ul>' + tradeoffs.slice(0, 4).map(function (item) { return '<li>' + escapeHtml(item) + '</li>'; }).join('') + '</ul></div><a class="sdx-card__link" data-sdx-product-link data-tool="' + escapeHtml(tool) + '" data-handle="' + escapeHtml(product.handle) + '" href="' + escapeHtml(product.url) + '">Review product details</a></div></article>';
  }

  function ownerStoryCallout() {
    var storyUrl = window.SweatDecksCustomerStoriesUrl || '/pages/customer-stories';
    return '<aside class="sdx-finder-story"><div><span class="sdx-eyebrow">Owner perspective</span><h3>See how real buyers moved from decision to daily use.</h3><p>Short interviews cover project coordination, installation, support, and how the sauna fits life at home.</p></div><a class="sdx-button sdx-button--secondary" data-sdx-story-link data-tool="finder" href="' + escapeHtml(storyUrl) + '">Watch customer stories</a></aside>';
  }

  function initFinder(root, products) {
    var form = root.querySelector('[data-sdx-form]');
    var results = root.querySelector('[data-sdx-results]');
    hydrateForm(form, projectData('finder'), ['capacity', 'placement', 'productType', 'budget', 'availableOnly']);
    form.addEventListener('submit', function (event) {
      event.preventDefault();
      if (!form.reportValidity()) return;
      emit('sdx_tool_started', { tool: 'finder' });
      var data = new FormData(form);
      var budget = number(data, 'budget');
      if (Number.isNaN(budget) || (budget !== null && budget < 0)) return renderError(root, 'invalid_input', 'Enter a valid product budget or leave it blank.');
      var ranked = rankFinder(products, {
        capacity: Number(data.get('capacity')),
        placement: String(data.get('placement') || ''),
        productType: String(data.get('productType') || ''),
        budget: budget,
        availableOnly: data.get('availableOnly') === 'on'
      });
      var shown = ranked;
      results.innerHTML = '<div class="sdx-summary"><h2>' + (shown.length ? 'Your ranked short list' : 'No eligible products met every selected limit') + '</h2><p>' + (shown.length ? 'Ranked from the preferences you supplied. This is decision support, not an approval or a match percentage.' : 'Try including currently unavailable products or changing a preference.') + '</p><p><strong>' + shown.length + '</strong> result' + (shown.length === 1 ? '' : 's') + ' shown from ' + products.length + ' eligible catalog records.</p></div>' + (shown.length ? '<div class="sdx-card-grid">' + shown.map(function (result) { return resultCard(result, 'finder'); }).join('') + '</div>' + ownerStoryCallout() : '');
      saveProjectStep('finder', {
        capacity: Number(data.get('capacity')) || null,
        placement: String(data.get('placement') || ''),
        productType: String(data.get('productType') || ''),
        budget: budget,
        availableOnly: data.get('availableOnly') === 'on',
        handles: shown.map(function (result) { return result.product.handle; })
      }, shown.length + ' products shortlisted for ' + (data.get('capacity') || 'unspecified') + '-person capacity, ' + (data.get('placement') || 'any') + ' placement, ' + (data.get('productType') || 'any') + ' style' + (finite(budget) ? ', product budget ' + money(budget, 'USD') : '') + '.');
      addPlanActions(root, 'Sauna finder short list');
      emit('sdx_tool_completed', { tool: 'finder', result_count: shown.length });
      focusResults(results);
    });
    form.addEventListener('reset', function () {
      window.setTimeout(function () {
        results.innerHTML = '<div class="sdx-empty"><h2>Your short list</h2><p>Tell us what matters above. We’ll rank the eligible catalog without hiding uncertainty.</p></div>';
        removeProjectStep('finder');
        emit('sdx_tool_reset', { tool: 'finder' });
      }, 0);
    });
  }

  function compareValue(value, formatter) {
    if (value == null || value === '' || (Array.isArray(value) && !value.length)) return '<span class="sdx-table__unknown">' + UNKNOWN + '</span>';
    return formatter ? formatter(value) : escapeHtml(value);
  }
  function initCompare(root, products) {
    var form = root.querySelector('[data-sdx-form]');
    var picker = root.querySelector('[data-sdx-compare-picker]');
    var results = root.querySelector('[data-sdx-results]');
    var status = root.querySelector('[data-sdx-selection-status]');
    var storageKey = 'sdx_compare_handles';
    var saved = [];
    try { saved = JSON.parse(sessionStorage.getItem(storageKey) || '[]').filter(function (handle) { return typeof handle === 'string'; }); } catch (_) { saved = []; }
    var projectCompare = projectData('compare');
    var projectFinder = projectData('finder');
    if (!saved.length && projectCompare && Array.isArray(projectCompare.handles)) saved = projectCompare.handles;
    if (!saved.length && projectFinder && Array.isArray(projectFinder.handles)) saved = projectFinder.handles.slice(0, 2);
    picker.innerHTML = products.slice().sort(function (a, b) { return a.title.localeCompare(b.title); }).map(function (product) {
      return '<label><input type="checkbox" name="handles" value="' + escapeHtml(product.handle) + '"' + (saved.indexOf(product.handle) !== -1 ? ' checked' : '') + '><span>' + escapeHtml(product.title) + '</span></label>';
    }).join('');
    function checked() { return Array.prototype.slice.call(form.querySelectorAll('input[name="handles"]:checked')); }
    function update(changed) {
      var selected = checked();
      if (selected.length > 4 && changed) { changed.checked = false; selected = checked(); }
      form.querySelectorAll('input[name="handles"]').forEach(function (input) { input.disabled = selected.length >= 4 && !input.checked; });
      status.textContent = selected.length + ' of 4 selected.';
      try { sessionStorage.setItem(storageKey, JSON.stringify(selected.map(function (input) { return input.value; }))); } catch (_) { /* Persistence is optional. */ }
      emit('sdx_compare_updated', { product_count: selected.length });
    }
    picker.addEventListener('change', function (event) { update(event.target); });
    update();
    form.addEventListener('submit', function (event) {
      event.preventDefault();
      var handles = checked().map(function (input) { return input.value; });
      if (handles.length < 2) {
        results.innerHTML = '<div class="sdx-notice sdx-notice--warning"><h2>Select at least two products</h2><p>You can compare two, three, or four saunas at a time.</p></div>';
        emit('sdx_tool_error', { tool: 'compare', code: 'selection_required' });
        return focusResults(results);
      }
      emit('sdx_tool_started', { tool: 'compare' });
      var selected = handles.map(function (handle) { return products.find(function (product) { return product.handle === handle; }); }).filter(Boolean);
      var rows = [
        ['Current starting price', function (p) { return compareValue(p.price && p.price.min, function (v) { return money(v, p.price.currency); }); }],
        ['Listed capacity', function (p) { return compareValue(p.capacity, function (v) { return escapeHtml(v + (v === 1 ? ' person' : ' people')); }); }],
        ['Placement', function (p) { return compareValue(p.placement, function (v) { return list(v); }); }],
        ['Style', function (p) { return compareValue(p.productType); }],
        ['Heat type', function (p) { return compareValue(p.heatType); }],
        ['Exterior dimensions', function (p) { return compareValue(p.exterior && p.exterior.display); }],
        ['Store availability', function (p) { return p.available ? 'Marked available' : 'Marked unavailable'; }],
        ['Still to confirm', function (p) { return p.unknowns && p.unknowns.length ? '<span class="sdx-table__unknown">' + escapeHtml(p.unknowns.join(', ').replace(/-/g, ' ')) + '</span>' : 'No unresolved catalog fields listed'; }]
      ];
      results.innerHTML = '<div class="sdx-table-wrap"><table class="sdx-table"><caption>Selected sauna comparison</caption><thead><tr><th scope="col">Specification</th>' + selected.map(function (p) { return '<th scope="col"><a data-sdx-product-link data-tool="compare" data-handle="' + escapeHtml(p.handle) + '" href="' + escapeHtml(p.url) + '">' + escapeHtml(p.title) + '</a></th>'; }).join('') + '</tr></thead><tbody>' + rows.map(function (row) { return '<tr><th scope="row">' + escapeHtml(row[0]) + '</th>' + selected.map(function (p) { return '<td>' + row[1](p) + '</td>'; }).join('') + '</tr>'; }).join('') + '</tbody></table></div><p class="sdx-help"><strong>Unknown</strong> means the catalog does not list this value; it does not mean zero. <strong>Not applicable</strong> would mean a field definitively does not apply to that product. No field is labeled not applicable without source evidence. Confirm current product details, compatibility, delivery, and project requirements before ordering.</p>';
      saveProjectStep('compare', { handles: handles, titles: selected.map(function (product) { return product.title; }) }, selected.length + ' products compared: ' + selected.map(function (product) { return product.title; }).join(', ') + '.');
      addPlanActions(root, 'Sauna comparison');
      emit('sdx_tool_completed', { tool: 'compare', result_count: selected.length });
      focusResults(results);
    });
    form.addEventListener('reset', function () {
      window.setTimeout(function () {
        try { sessionStorage.removeItem(storageKey); } catch (_) {}
        removeProjectStep('compare');
        update();
        results.innerHTML = '<div class="sdx-table-wrap"><table class="sdx-table"><caption>Sauna comparison</caption><thead><tr><th scope="col">Specification</th><th scope="col">Choose two to four products to compare</th></tr></thead><tbody><tr><th scope="row">Status</th><td>Waiting for product selections.</td></tr></tbody></table></div>';
        emit('sdx_tool_reset', { tool: 'compare' });
      }, 0);
    });
  }

  function initCost(root) {
    var form = root.querySelector('[data-sdx-form]');
    var results = root.querySelector('[data-sdx-results]');
    var groups = ['delivery', 'installation', 'site', 'electrical'];
    var savedCost = projectData('cost');
    hydrateForm(form, savedCost, ['product', 'deliveryLow', 'deliveryHigh', 'installationLow', 'installationHigh', 'siteLow', 'siteHigh', 'electricalLow', 'electricalHigh']);
    if (!savedCost) {
      var savedFinder = projectData('finder');
      if (savedFinder && finite(savedFinder.budget)) hydrateForm(form, { product: savedFinder.budget }, ['product']);
    }
    form.addEventListener('submit', function (event) {
      event.preventDefault();
      if (!form.reportValidity()) return;
      emit('sdx_tool_started', { tool: 'cost' });
      var data = new FormData(form);
      var product = number(data, 'product');
      var low = product;
      var high = product;
      var invalid = !finite(product) || product < 0;
      var assumptions = [];
      groups.forEach(function (group) {
        var lowValue = number(data, group + 'Low');
        var highValue = number(data, group + 'High');
        if (!finite(lowValue) || !finite(highValue) || lowValue < 0 || highValue < lowValue) invalid = true;
        low += lowValue || 0;
        high += highValue || 0;
        assumptions.push(group.charAt(0).toUpperCase() + group.slice(1) + ': ' + money(lowValue, 'USD') + ' to ' + money(highValue, 'USD'));
      });
      if (invalid) return renderError(root, 'invalid_input', 'Use non-negative amounts and keep each high assumption at or above its low assumption.');
      results.innerHTML = '<div class="sdx-summary"><h2>Planning range</h2><p>Based entirely on the assumptions you entered.</p></div><div class="sdx-total"><div><span>Low planning total</span><strong>' + money(low, 'USD') + '</strong></div><div><span>High planning total</span><strong>' + money(high, 'USD') + '</strong></div></div><div class="sdx-assumptions"><h3>Your assumptions</h3><ul><li>Products: ' + money(product, 'USD') + '</li>' + assumptions.map(function (item) { return '<li>' + escapeHtml(item) + '</li>'; }).join('') + '</ul><h3>Not included unless you added it above</h3><p>Taxes, permits, design or engineering, demolition, utilities beyond electrical, drainage, weatherproofing, crane or special access, maintenance, and future operating costs.</p><p><strong>This is a non-binding planning range, not a quote.</strong> Product configuration, site conditions, delivery eligibility, local labor, and code requirements can change the total. Request written scopes from the relevant parties before committing.</p></div>';
      saveProjectStep('cost', {
        product: product,
        deliveryLow: number(data, 'deliveryLow'), deliveryHigh: number(data, 'deliveryHigh'),
        installationLow: number(data, 'installationLow'), installationHigh: number(data, 'installationHigh'),
        siteLow: number(data, 'siteLow'), siteHigh: number(data, 'siteHigh'),
        electricalLow: number(data, 'electricalLow'), electricalHigh: number(data, 'electricalHigh'),
        low: low, high: high, assumptions: assumptions
      }, 'Planning range ' + money(low, 'USD') + ' to ' + money(high, 'USD') + ', based entirely on entered product, delivery, installation, site, and electrical assumptions.');
      addPlanActions(root, 'Project cost planning range');
      emit('sdx_tool_completed', { tool: 'cost', result_count: 1 });
      focusResults(results);
    });
    form.addEventListener('reset', function () { window.setTimeout(function () { results.innerHTML = '<div class="sdx-empty"><h2>Project planning range</h2><p>Enter your own assumptions. We do not insert unverified shipping or labor promises.</p></div>'; removeProjectStep('cost'); emit('sdx_tool_reset', { tool: 'cost' }); }, 0); });
  }

  function initHeater(root) {
    var form = root.querySelector('[data-sdx-form]');
    var results = root.querySelector('[data-sdx-results]');
    hydrateForm(form, projectData('heater'), ['length', 'width', 'height', 'factor']);
    form.addEventListener('submit', function (event) {
      event.preventDefault();
      if (!form.reportValidity()) return;
      emit('sdx_tool_started', { tool: 'heater' });
      var data = new FormData(form);
      var length = number(data, 'length'); var width = number(data, 'width'); var height = number(data, 'height'); var factor = number(data, 'factor');
      if (![length, width, height].every(function (v) { return finite(v) && v > 0; }) || Number.isNaN(factor) || (factor !== null && factor <= 0)) return renderError(root, 'invalid_input', 'Enter positive room dimensions and, if used, a positive factor from the exact manufacturer rules.');
      var raw = length * width * height;
      var adjusted = factor === null ? null : raw * factor;
      results.innerHTML = '<div class="sdx-summary"><h2>Calculated room volume</h2><p><strong>' + raw.toLocaleString('en-US', { maximumFractionDigits: 1 }) + ' cubic feet</strong></p>' + (adjusted !== null ? '<p>With your manufacturer factor of ' + escapeHtml(factor) + ': <strong>' + adjusted.toLocaleString('en-US', { maximumFractionDigits: 1 }) + ' adjusted cubic feet</strong></p>' : '<p>No adjustment factor applied.</p>') + '</div><div class="sdx-notice sdx-notice--warning"><h2>This does not select a heater</h2><p>Use the calculated volume only with the current sizing instructions for the exact heater and room construction. SweatDecks v1 does not have normalized primary-source rules needed to recommend kW, electrical service, controls, ventilation, clearances, or compatibility.</p><p>Have the final selection and installation reviewed against the manufacturer instructions, product listing, applicable code, and a qualified electrician or other required trade.</p></div>';
      saveProjectStep('heater', { length: length, width: width, height: height, rawCubicFeet: raw, factor: factor, adjustedCubicFeet: adjusted }, 'Room volume ' + raw.toLocaleString('en-US', { maximumFractionDigits: 1 }) + ' cubic feet' + (adjusted !== null ? '; entered manufacturer factor produces ' + adjusted.toLocaleString('en-US', { maximumFractionDigits: 1 }) + ' adjusted cubic feet' : '; no adjustment factor applied') + '.');
      addPlanActions(root, 'Heater room-volume calculation');
      emit('sdx_tool_completed', { tool: 'heater', result_count: 1 });
      focusResults(results);
    });
    form.addEventListener('reset', function () { window.setTimeout(function () { results.innerHTML = '<div class="sdx-empty"><h2>Room volume</h2><p>Enter finished interior dimensions to create a number you can check against an exact manufacturer manual.</p></div>'; removeProjectStep('heater'); emit('sdx_tool_reset', { tool: 'heater' }); }, 0); });
  }

  function exactDimensions(product, group) {
    var dimensions = product[group];
    return dimensions && ['widthIn', 'depthIn', 'heightIn'].every(function (key) { return finite(dimensions[key]); });
  }
  function initSpace(root, products) {
    var form = root.querySelector('[data-sdx-form]');
    var results = root.querySelector('[data-sdx-results]');
    var eligible = products.filter(function (product) { return exactDimensions(product, 'exterior'); });
    var savedSpace = projectData('space');
    hydrateForm(form, savedSpace && savedSpace.measurements, ['spaceWidth', 'spaceDepth', 'spaceHeight', 'clearLeft', 'clearRight', 'clearFront', 'clearBack', 'clearTop', 'accessWidth']);
    form.addEventListener('submit', function (event) {
      event.preventDefault();
      if (!form.reportValidity()) return;
      emit('sdx_tool_started', { tool: 'space' });
      var data = new FormData(form);
      var values = {};
      ['spaceWidth', 'spaceDepth', 'spaceHeight', 'clearLeft', 'clearRight', 'clearFront', 'clearBack', 'clearTop', 'accessWidth'].forEach(function (key) { values[key] = number(data, key); });
      var valid = Object.keys(values).every(function (key) { return finite(values[key]) && values[key] >= (key.indexOf('clear') === 0 ? 0 : 1); });
      if (!valid) return renderError(root, 'invalid_input', 'Enter positive usable-space and access measurements, plus non-negative sourced clearances.');
      var checks = eligible.map(function (product) {
        var requiredWidth = product.exterior.widthIn + values.clearLeft + values.clearRight;
        var requiredDepth = product.exterior.depthIn + values.clearFront + values.clearBack;
        var requiredHeight = product.exterior.heightIn + values.clearTop;
        var fits = requiredWidth <= values.spaceWidth && requiredDepth <= values.spaceDepth && requiredHeight <= values.spaceHeight;
        var access = 'Access not evaluated. Complete sourced package dimensions are unavailable.';
        if (exactDimensions(product, 'shipping')) {
          var smallestSide = Math.min(product.shipping.widthIn, product.shipping.depthIn, product.shipping.heightIn);
          access = values.accessWidth < smallestSide ? 'Access warning: your opening is narrower than the smallest listed package side (' + smallestSide + ' in).' : 'Access checkpoint: the opening is not narrower than the smallest listed package side (' + smallestSide + ' in), but turns, length, weight, handling, and route conditions are not evaluated.';
        }
        return { product: product, fits: fits, requiredWidth: requiredWidth, requiredDepth: requiredDepth, requiredHeight: requiredHeight, access: access };
      }).sort(function (a, b) { return Number(b.fits) - Number(a.fits) || a.product.title.localeCompare(b.product.title); });
      results.innerHTML = '<div class="sdx-summary"><h2>Potential placement fit</h2><p>' + checks.filter(function (check) { return check.fits; }).length + ' of ' + checks.length + ' products with complete normalized exterior dimensions fit the measurements and clearances you supplied.</p><p>The other ' + (products.length - checks.length) + ' eligible catalog products were excluded from calculation because their numeric exterior dimensions are incomplete.</p></div><div class="sdx-card-grid">' + checks.map(function (check) {
        var p = check.product;
        return '<article class="sdx-card sdx-fit ' + (check.fits ? '' : 'sdx-fit--no') + '"><div class="sdx-card__body"><span class="sdx-badge">' + (check.fits ? 'Potential dimensional fit' : 'Does not fit supplied dimensions') + '</span><h3>' + escapeHtml(p.title) + '</h3><p>Exterior: ' + escapeHtml(p.exterior.display) + '</p><p>Space required with your clearances: <strong>' + check.requiredWidth.toFixed(1) + ' W × ' + check.requiredDepth.toFixed(1) + ' D × ' + check.requiredHeight.toFixed(1) + ' H in</strong></p><p>' + escapeHtml(check.access) + '</p><a class="sdx-card__link" data-sdx-product-link data-tool="space" data-handle="' + escapeHtml(p.handle) + '" href="' + escapeHtml(p.url) + '">Verify product and manuals</a></div></article>';
      }).join('') + '</div><div class="sdx-notice sdx-notice--warning"><h2>Potential fit is not approval</h2><p>Confirm the current exact-model manual, door swing, service access, heater and ventilation clearances, foundation, structure, moisture and weather conditions, delivery route, utilities, permits, and applicable code with the manufacturer and qualified project professionals.</p></div>';
      var fitting = checks.filter(function (check) { return check.fits; });
      saveProjectStep('space', { measurements: values, fittingHandles: fitting.map(function (check) { return check.product.handle; }), evaluatedCount: checks.length }, fitting.length + ' of ' + checks.length + ' products with complete normalized dimensions fit the supplied usable space and sourced clearances; access and project approval remain unconfirmed.');
      addPlanActions(root, 'Sauna space fit check');
      emit('sdx_tool_completed', { tool: 'space', result_count: checks.length });
      focusResults(results);
    });
    form.addEventListener('reset', function () { window.setTimeout(function () { results.innerHTML = '<div class="sdx-empty"><h2>Potential fit check</h2><p>Only products with sourced numeric exterior dimensions can appear in calculated fit results.</p></div>'; removeProjectStep('space'); emit('sdx_tool_reset', { tool: 'space' }); }, 0); });
  }

  function initialize(root) {
    if (root.getAttribute('data-sdx-ready') === 'true') return;
    var tool = root.getAttribute('data-sdx-tool');
    var form = root.querySelector('[data-sdx-form]');
    if (!form) return;
    // Planning is local. Never send a native POST to a Shopify content page.
    form.addEventListener('submit', function (event) { event.preventDefault(); });
    try {
      if (tool === 'cost') initCost(root);
      else if (tool === 'heater') initHeater(root);
      else {
        var products = productData();
        if (!products || !products.length) return renderError(root, 'data_unavailable', 'The current product data did not load. No recommendation or fit calculation has been made.');
        if (tool === 'finder') initFinder(root, products);
        else if (tool === 'compare') initCompare(root, products);
        else if (tool === 'space') initSpace(root, products);
        else return;
      }
      root.setAttribute('data-sdx-ready', 'true');
      root.querySelectorAll('[data-sdx-controls]').forEach(function (control) { control.disabled = false; });
      var pending = root.querySelector('[data-sdx-pending]');
      if (pending) pending.hidden = true;
    } catch (_) { renderError(root, 'render_failed', 'The tool encountered an unexpected problem. No recommendation or fit calculation has been made.'); }
  }

  document.addEventListener('click', function (event) {
    var exportButton = event.target.closest && event.target.closest('[data-sdx-export]');
    if (exportButton) return exportPlan(exportButton);
    var link = event.target.closest && event.target.closest('[data-sdx-product-link]');
    if (link) emit('sdx_product_opened', { tool: link.getAttribute('data-tool'), handle: link.getAttribute('data-handle') });
    var storyLink = event.target.closest && event.target.closest('[data-sdx-story-link]');
    if (storyLink) emit('sdx_story_opened', { tool: storyLink.getAttribute('data-tool') });
  });
  function boot() { document.querySelectorAll('[data-sdx-tool]').forEach(initialize); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  document.addEventListener('shopify:section:load', function (event) { event.target.querySelectorAll('[data-sdx-tool]').forEach(initialize); });

  window.SDXTools = { emit: emit };
  window.SDXToolsModel = { rankFinder: rankFinder, exactDimensions: exactDimensions, money: money, unknownLabel: UNKNOWN };
}());